// "All systems operational" pill — polls /api/health and shows the live
// status in the site footer. Keeps the request budget tiny: 60s interval,
// AbortController on unmount, no retry on transient errors.

import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export const SystemStatusPill = () => {
    const [state, setState] = useState({ status: null, lastChecked: null });

    useEffect(() => {
        let mounted = true;
        let controller;
        const tick = async () => {
            controller = new AbortController();
            try {
                const r = await api.get("/health", { signal: controller.signal });
                if (!mounted) return;
                setState({ status: r.data.status, lastChecked: Date.now() });
            } catch {
                if (!mounted) return;
                setState({ status: "down", lastChecked: Date.now() });
            }
        };
        tick();
        const iv = setInterval(tick, 60_000);
        return () => {
            mounted = false;
            if (controller) controller.abort();
            clearInterval(iv);
        };
    }, []);

    if (!state.status) return null;
    const isOk = state.status === "ok";
    const isDegraded = state.status === "degraded";
    const colour = isOk ? "bg-[#CCFF00]" : isDegraded ? "bg-[#FFA500]" : "bg-[#FF00FF] text-white";
    const dot = isOk ? "bg-black" : isDegraded ? "bg-black" : "bg-white";
    const label = isOk ? "All systems go" : isDegraded ? "Degraded" : "Service down";

    return (
        <a
            href="/api/health"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="system-status-pill"
            aria-label={`System status: ${label}`}
            className={`inline-flex items-center gap-2 border-2 border-black px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest shadow-brutal-sm ${colour}`}
        >
            <span className={`w-2 h-2 rounded-full ${dot} animate-pulse`} />
            {label}
        </a>
    );
};
